module.exports = __webpack_public_path__ + "media/details/recruitment@2x-1f2ccd65.png";